var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"aboutUs"}},[_c('br'),_c('br'),_c('div',{attrs:{"id":"text"}},[_c('h1',[_vm._v(" O que te "),_c('span',[_vm._v("MOTIVA")]),_c('br'),_vm._v(" a entrar em ação? ")]),_c('br'),_c('h3',[_vm._v(" Buscamos semear o melhor para a sua vida todos os"),_c('br'),_vm._v("dias trazendo soluções inovadores. ")])])])
}]

export { render, staticRenderFns }